export default {
  sum: "sum",
  formated: "formated",
  text: "text",
  void: "void",
  avg: "avg",
};
export const defaultValues = {
  void: "--",
};
